module.exports = __webpack_public_path__ + "files/14828c5e9dba3e9ffb18d371fb75ebc2.png";